import "./LetsTalk.module.css";
import MainNavigation from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import RequestService from "./sections/RequestService";
import OurServiceArea from "./sections/OurServiceArea";
import FooterInformation from "@/reusable_sections/Footer";
export default function LetsTalkPage() {
  return <div>
      <MainNavigation />
      <GetInTouch />
      <RequestService />
      <OurServiceArea />
      <FooterInformation />
    </div>;
}